export class WebsiteConstants {
    public static SiteTitle: string = "Jiveshwar Sali Reshimgathi";
    public static SiteUrl: string = "https://www.jiveshwarsalireshimgathi.com/";
    public static MasterUrl: string = "https://www.jiveshwarsalireshimgathi.com/webmaster/";
}
